module.exports = __webpack_public_path__ + "static/media/25.8fbfc20e.mp3";